import React, { ChangeEvent, Fragment } from 'react';
import '../../../App.css';
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import PropertyGroup from "./propertygroup";
import { getDefaultPropertyPaletteRenderer, getPropertyPaletteRenderer } from '../../Editor/util/shapeCategorySingleton';
import { RootState } from "../../../store/store";
import { changeEditMode } from '../../../store/tool';
import { findToolToShape } from './util/helperFunctions';


const Propertybar = () => {
  const selection = useAppSelector((state: RootState) => state.model.present.selected)
  const shapes = useAppSelector((state: RootState) => state.model.present.model.shapes)
  const currentTool = useAppSelector((state: RootState) => state.tool.currentTool)
  const toolSettings = useAppSelector((state: RootState) => state.tool.toolSettings)
  const dispatch = useAppDispatch();

  const currentToolEditingMode = (tool: ToolType) => {
    return (
      < PropertyGroup
        titleComponent={{
          title: 'Editing Options',
          name: '',
          id: '',
        }}
        //groupContent= {EditingMode}
        groupContent={
          <div>
            <p>
              {toolSettings[tool].validEditMode.map((mode) => {
                return (
                  <label key={mode} >
                    <input
                      type="radio"
                      name="myRadio"
                      value={mode}
                      defaultChecked={
                        mode === toolSettings[tool].currentEditMode ||
                        mode === toolSettings[findToolToShape(shapes.find(x => x.id === selection.selectedItemIds[0])?.type)].currentEditMode
                      }
                      onChange={(e: ChangeEvent<HTMLInputElement>) => {
                        dispatch(changeEditMode({ t: tool, e: e?.target.value as EditType }))
                      }}
                    />
                    {mode}
                  </label>
                )
              }
              )}
            </p>
          </div>
        }
      />

    )
  }


  function definitonSettings() {
    const settings = toolSettings[currentTool];
    if (settings.functionCategory === "definition") {
      return (
        getDefaultPropertyPaletteRenderer?.(currentTool)?.(settings.current)
      )
    }
  }
  return (
    <Fragment>
      {/* The Default settings, definition Palett */}
      {toolSettings[currentTool] &&
        < PropertyGroup
          titleComponent={{
            title: "Definition Settings",
            name: currentTool,
            id: "",
          }}
          groupContent={definitonSettings()}
        />
      }

      {/* Editing mode options */}
      {// If there is a definition type to the only selected element then show it.
        (selection.selectedItemIds.length === 1 && (toolSettings[findToolToShape(shapes.find(x => x.id === selection.selectedItemIds[0])?.type)].validEditMode.length) > 0) &&
        // Call the editing mode reder with the selected items ToolType
        currentToolEditingMode(findToolToShape(shapes.find(x => x.id === selection.selectedItemIds[0])?.type))}

      {/* Settings related to selected Items */}
      {selection.selectedItemIds?.map((itemId) => {
        const selectedShape = shapes.find(shape => shape.id === itemId);
        if (selectedShape) {
          return (
            < PropertyGroup
              key={selectedShape.id}
              titleComponent={{
                title: "Name",
                name: selectedShape.type,
                id: selectedShape.id.toString(),
              }}
              groupContent={getPropertyPaletteRenderer?.(selectedShape.type)?.(selectedShape)}
            />
          )
        } else {
          return undefined
        }
      }
      )
      }


    </Fragment>
  )
};

export default Propertybar;